var map = {
	"./environment": "./src/environments/environment.ts",
	"./environment.dev": "./src/environments/environment.dev.ts",
	"./environment.dev.ts": "./src/environments/environment.dev.ts",
	"./environment.prod": "./src/environments/environment.prod.ts",
	"./environment.prod.ts": "./src/environments/environment.prod.ts",
	"./environment.stage": "./src/environments/environment.stage.ts",
	"./environment.stage.ts": "./src/environments/environment.stage.ts",
	"./environment.ts": "./src/environments/environment.ts"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/environments recursive ^\\.\\/environment.*$";


//////////////////
// WEBPACK FOOTER
// ./src/environments ^\.\/environment.*$
// module id = ./src/environments recursive ^\.\/environment.*$
// module chunks = main